import React, { useState, useEffect } from 'react';
import { Edit2, Save, X, RefreshCw, AlertCircle, CheckCircle, Plus, Trash2 } from 'lucide-react';
import Select from 'react-select';
import NavBar from '../../../../component/b2b/navBar/b2bNavBar';
import Sidebar from '../../../../component/b2b/sideBar/b2bSideBar';
import { useMyContext } from '../../../../context/MyContext';
import { Base_Url, fetchUser, b2bsetprice, getRetailerPrice } from '../../../../config/config';
import RateCsvUplod from '../../Admin/SetRate/component/ratecsvuplaod';

const B2BSetRate = () => {
    const [activeTab, setActiveTab] = useState("customized");
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const { isDarkMode, isToggleSidebar } = useMyContext();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [editingCell, setEditingCell] = useState(null);
    const [editValue, setEditValue] = useState('');
    const [saving, setSaving] = useState(false);

    const [selectedRetailer, setSelectedRetailer] = useState(null);
    const [selectedCourier, setSelectedCourier] = useState('');
    const [selectedCftType, setSelectedCftType] = useState('');

    const [zonePricing, setZonePricing] = useState({});
    const [vasPricing, setVasPricing] = useState([]);
    const [showVasModal, setShowVasModal] = useState(false);

    const [retailers, setRetailers] = useState([]);

    const courierPartners = [
        { id: 'delhivery', name: 'Delhivery' },
        { id: 'movin', name: 'movin' },
        { id: 'gati', name: 'gati' },
    ];

    const zones = ['n1', 'n2', 'n3', 'n4', 'c1', 'c2', 'w1', 'w2', 's1', 's2', 's3', 's4', 'e1', 'e2', 'ne1', 'ne2'];

    const zoneLabels = {
        n1: 'N1', n2: 'N2', n3: 'N3', n4: 'N4',
        c1: 'C1', c2: 'C2',
        w1: 'W1', w2: 'W2',
        s1: 'S1', s2: 'S2', s3: 'S3', s4: 'S4',
        e1: 'E1', e2: 'E2',
        ne1: 'NE1', ne2: 'NE2'
    };

    const lockedChargeKeys = ["processing", "fsc", "rov_owner", "rov_carrier", "handling", "oda", "demurrage", "csd_delivery", "re_attempt", "pickup_charge", "to_pay", "cheque_handling", "cash_handling", "green_tax", "min_lr_charge", "gst"];

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    useEffect(() => {
        initializeDefaultPricing();
        initializeDefaultVAS();
        fetchRetailers();
    }, []);

    const fetchRetailers = async () => {
        const url = Base_Url + fetchUser;
        setLoading(true);
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    token: token,
                    cus_id: cus_id,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data.status === "success") {
                const transformedData = data.data.map(user => {
                    const capitalizedName = user.name.charAt(0).toUpperCase() + user.name.slice(1);
                    return {
                        value: user.id,
                        label: `${capitalizedName} (${user.id})`,
                        id: user.id,
                        name: capitalizedName
                    };
                });
                setRetailers(transformedData);
            } else {
                setError(`Error: ${data.message} ${data.code ? `(Code: ${data.code})` : ''}`);
            }
        } catch (error) {
            setError(`Error fetching retailers: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const initializeDefaultPricing = () => {
        const defaultPricing = {};
        zones.forEach(fromZone => {
            defaultPricing[fromZone] = {};
            zones.forEach(toZone => {
                defaultPricing[fromZone][toZone] = '0';
            });
        });
        setZonePricing(defaultPricing);
    };

    const initializeDefaultVAS = () => {
        setVasPricing([
            {
                charge_key: 'cod_charge',
                label: 'COD Collection Fee',
                charge_type: 'percent',
                condition_value: 'invoice',
                value: '2.5',
                min_value: '20.00',
                max_value: '200.00',
                is_active: true
            },
            {
                charge_key: 'insurance',
                label: 'Insurance',
                charge_type: 'percent',
                condition_value: 'subtotal',
                value: '0.5',
                min_value: '',
                max_value: '',
                is_active: true
            },
            {
                charge_key: 'handling_fee',
                label: 'Handling Fee',
                charge_type: 'fixed',
                condition_value: 'base',
                value: '15.00',
                min_value: '',
                max_value: '',
                is_active: false
            }
        ]);
    };

    const fetchRetailerPrice = async (retailerId, courierPartner, cftType) => {
        setLoading(true);
        setError(null);
        setDataLoaded(false);
        try {
            const apiUrl = Base_Url + getRetailerPrice;
            const requestBody = {
                retailer_id: retailerId,
                partner: courierPartner,
                type: cftType
            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'cus_id': cus_id,
                    'token': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();
            if (response.ok && data.status === 'success') {
                if (data.data.zone_pricing) {
                    const zonePricingData = JSON.parse(data.data.zone_pricing);
                    setZonePricing(zonePricingData);
                } else {
                    initializeDefaultPricing();
                }

                if (data.data.vas_pricing) {
                    const vasPricingData = JSON.parse(data.data.vas_pricing);
                    setVasPricing(vasPricingData);
                } else {
                    initializeDefaultVAS();
                }

                setDataLoaded(true);
                setSuccess('Pricing data loaded successfully!');
                setTimeout(() => setSuccess(null), 1000);
            } else {
                setError(`Error: ${data.message || 'Failed to fetch pricing'} ${data.code ? `(Code: ${data.code})` : ''}`);
            }
        } catch (error) {
            setError(`Error fetching pricing: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let timeoutId;
        if (selectedRetailer && selectedCourier) {
            setDataLoaded(false);
            timeoutId = setTimeout(() => {
                fetchRetailerPrice(selectedRetailer.value, selectedCourier, selectedCftType);
            }, 800);
        } else {
            setDataLoaded(false);
        }

        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [selectedRetailer, selectedCourier, selectedCftType]);

    const setPricing = async () => {
        if (!selectedRetailer) {
            setError('Please select a retailer');
            return;
        }
        if (!selectedCourier) {
            setError('Please select a courier partner');
            return;
        }

        setSaving(true);
        setError(null);
        setSuccess(null);

        try {
            const apiUrl = Base_Url + b2bsetprice;
            const requestBody = {
                retailer_id: selectedRetailer.value,
                courier_partner: selectedCourier,
                cft_type: selectedCftType,
                zone_pricing: zonePricing,
                vas_pricing: vasPricing
            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'cus_id': cus_id,
                    'token': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (response.ok && data.status === 'success') {
                setSuccess('Pricing updated successfully!');
                setTimeout(() => setSuccess(null), 3000);
            } else {
                setError(`Error: ${data.message || 'Failed to update pricing'} ${data.code ? `(Code: ${data.code})` : ''}`);
            }
        } catch (error) {
            setError(`Error updating pricing: ${error.message}`);
        } finally {
            setSaving(false);
        }
    };

    const handleCellEdit = (fromZone, toZone, currentValue) => {
        setEditingCell(`${fromZone}-${toZone}`);
        setEditValue(currentValue);
    };

    const handleSaveEdit = (fromZone, toZone) => {
        if (editValue === '' || isNaN(parseFloat(editValue))) {
            setError('Please enter a valid number');
            return;
        }

        // Immutable update (functional form) so the edited rate reliably
        // reflects in state and Save always sends the latest value.
        setZonePricing(prev => ({
            ...prev,
            [fromZone]: {
                ...prev[fromZone],
                [toZone]: editValue
            }
        }));

        setEditingCell(null);
        setEditValue('');
        setError(null);
    };

    const handleCancelEdit = () => {
        setEditingCell(null);
        setEditValue('');
    };

    const updateVasField = (index, field, value) => {
        const updated = [...vasPricing];
        updated[index][field] = value;
        setVasPricing(updated);
    };

    const addVasRow = () => {
        setVasPricing([
            ...vasPricing,
            {
                charge_key: '',
                label: '',
                charge_type: 'fixed',
                condition_value: '',
                value: '',
                min_value: '',
                max_value: '',
                is_active: true
            }
        ]);
    };

    const removeVasRow = (index) => {
        const updated = vasPricing.filter((_, i) => i !== index);
        setVasPricing(updated);
    };

    // Custom styles for react-select - Indigo/Purple in dark, Black & White in light
    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            height: '32px',
            minHeight: '32px',
            borderColor: state.isFocused
                ? (isDarkMode ? '#6366f1' : '#000000')
                : isDarkMode ? 'rgba(99,102,241,0.3)' : '#d1d5db',
            borderRadius: '0.5rem',
            fontSize: '0.7rem',
            background: isDarkMode ? 'rgba(0,0,0,0.6)' : '#ffffff',
            color: isDarkMode ? '#ffffff' : '#000000',
            boxShadow: state.isFocused
                ? (isDarkMode ? '0 0 0 2px rgba(99,102,241,0.25)' : '0 0 0 2px rgba(0,0,0,0.1)')
                : 'none',
            '&:hover': {
                borderColor: isDarkMode ? '#818cf8' : '#000000'
            }
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '32px',
            padding: '0 8px'
        }),
        input: (provided) => ({
            ...provided,
            margin: '0',
            fontSize: '0.7rem',
            color: isDarkMode ? '#ffffff' : '#000000'
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: '0.7rem',
            backgroundColor: state.isSelected
                ? (isDarkMode ? '#4f46e5' : '#000000')
                : state.isFocused
                    ? (isDarkMode ? 'rgba(99,102,241,0.15)' : 'rgba(0,0,0,0.05)')
                    : 'transparent',
            color: state.isSelected ? '#ffffff' : isDarkMode ? '#ffffff' : '#000000',
            '&:active': {
                backgroundColor: isDarkMode ? '#4f46e5' : '#000000'
            }
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? 'rgba(165,180,252,0.5)' : '#9ca3af',
            fontSize: '0.7rem'
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: '0.7rem',
            color: isDarkMode ? '#ffffff' : '#000000'
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            fontSize: '0.7rem',
            background: isDarkMode ? 'rgba(0,0,0,0.95)' : '#ffffff',
            border: isDarkMode ? '1px solid rgba(99,102,241,0.35)' : '1px solid rgba(0,0,0,0.1)'
        }),
        menuList: (provided) => ({
            ...provided,
            background: isDarkMode ? 'rgba(0,0,0,0.95)' : '#ffffff'
        })
    };

    const renderRateTable = () => {
        if (!selectedRetailer || !selectedCourier) {
            return (
                <div className={`border rounded-xl p-8 text-center ${isDarkMode ? 'border-indigo-500/20 bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14]' : 'border-black/10 bg-white'}`}>
                    <AlertCircle className={`w-12 h-12 mx-auto mb-3 ${isDarkMode ? 'text-indigo-400/40' : 'text-gray-400'}`} />
                    <h3 className={`text-sm font-semibold mb-1 ${isDarkMode ? 'text-indigo-200' : 'text-gray-700'}`}>No Selection Made</h3>
                    <p className={`text-[10px] ${isDarkMode ? 'text-indigo-300/50' : 'text-gray-500'}`}>Select both a retailer and courier partner to view pricing matrix</p>
                </div>
            );
        }

        if (loading && !dataLoaded) {
            return (
                <div className={`border rounded-xl p-8 text-center ${isDarkMode ? 'border-indigo-500/20 bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14]' : 'border-black/10 bg-white'}`}>
                    <RefreshCw className={`w-12 h-12 mx-auto mb-3 animate-spin ${isDarkMode ? 'text-indigo-400' : 'text-black'}`} />
                    <h3 className={`text-sm font-semibold mb-1 ${isDarkMode ? 'text-indigo-200' : 'text-gray-700'}`}>Loading Pricing Data...</h3>
                    <p className={`text-[10px] ${isDarkMode ? 'text-indigo-300/50' : 'text-gray-500'}`}>Fetching pricing information...</p>
                </div>
            );
        }

        if (!dataLoaded) {
            return (
                <div className={`border rounded-xl p-8 text-center ${isDarkMode ? 'border-indigo-500/20 bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14]' : 'border-black/10 bg-white'}`}>
                    <RefreshCw className={`w-12 h-12 mx-auto mb-3 ${isDarkMode ? 'text-indigo-400/30' : 'text-gray-400'}`} />
                    <h3 className={`text-sm font-semibold mb-1 ${isDarkMode ? 'text-indigo-200' : 'text-gray-700'}`}>Waiting for Data...</h3>
                    <p className={`text-[10px] ${isDarkMode ? 'text-indigo-300/50' : 'text-gray-500'}`}>Please wait while we load the pricing data</p>
                </div>
            );
        }

        return (
            <div className={`border rounded-2xl overflow-hidden ${isDarkMode
                ? 'border-indigo-500/25 bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14] shadow-[0_8px_40px_rgba(79,70,229,0.25)]'
                : 'border-black/10'
                }`}>

                {/* Header */}
                <div className={`px-4 py-3 border-b ${isDarkMode
                    ? 'border-indigo-500/25 bg-gradient-to-r from-indigo-700 via-purple-700 to-indigo-700'
                    : 'border-black/10 bg-blue-600'
                    }`}>
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                        <div>
                            <h3 className={`text-sm font-bold tracking-wide ${isDarkMode ? 'text-white drop-shadow-[0_0_8px_rgba(255,255,255,0.3)]' : 'text-white'}`}>
                                Zone Pricing Matrix
                            </h3>
                            <p className={`text-[10px] mt-0.5 font-medium ${isDarkMode ? 'text-indigo-100/90' : 'text-white/70'}`}>
                                {courierPartners.find(c => c.id === selectedCourier)?.name} — {selectedRetailer?.label}
                            </p>
                        </div>
                        <button
                            onClick={() => setShowVasModal(true)}
                            className={`px-3.5 py-1.5 rounded-lg text-[10px] font-semibold transition-all duration-200 ${isDarkMode
                                ? 'bg-white/15 backdrop-blur-md text-white border border-white/30 hover:bg-white/25 shadow-lg shadow-indigo-900/30'
                                : 'bg-inherit shadow-lg border border-white text-white hover:bg-blue-700'
                                }`}
                        >
                            Manage VAS
                        </button>
                    </div>
                </div>

                {/* Table */}
                <div className="overflow-x-auto no-scrollbar">
                    <div className="inline-block min-w-full align-middle">
                        <table className="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr className={isDarkMode
                                    ? 'bg-gradient-to-r from-indigo-950/80 via-purple-950/60 to-indigo-950/80'
                                    : 'bg-black/5'
                                    }>
                                    <th className={`px-3 py-2.5 text-left text-[10px] font-bold uppercase tracking-wider border-b sticky left-0 z-20 ${isDarkMode
                                        ? 'border-indigo-500/30 text-indigo-200 bg-[#0b0b14]'
                                        : 'border-black/10 text-black/70 bg-white'
                                        }`}>
                                        From/To
                                    </th>
                                    {zones.map(zone => (
                                        <th key={zone} className={`px-2 py-2.5 text-center text-[9px] font-bold uppercase tracking-wider border-b ${isDarkMode
                                            ? 'border-indigo-500/30 text-indigo-200/90'
                                            : 'border-black/10 text-black/60'
                                            }`}>
                                            {zoneLabels[zone]}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {zones.map((fromZone, rowIdx) => (
                                    <tr key={fromZone} className={`group/row transition-colors ${isDarkMode
                                        ? rowIdx % 2 === 0
                                            ? 'bg-transparent hover:bg-indigo-500/5'
                                            : 'bg-indigo-500/[0.03] hover:bg-indigo-500/10'
                                        : 'hover:bg-black/5'
                                        }`}>
                                        <td className={`px-3 py-2 text-[10px] font-bold border-r border-b sticky left-0 z-10 ${isDarkMode
                                            ? 'border-indigo-500/20 text-indigo-200 bg-[#0b0b14] group-hover/row:bg-[#0f0f1c]'
                                            : 'border-black/10 text-black/70 bg-white'
                                            }`}>
                                            {zoneLabels[fromZone]}
                                        </td>
                                        {zones.map(toZone => {
                                            const rate = zonePricing[fromZone]?.[toZone] || '0';
                                            const cellId = `${fromZone}-${toZone}`;
                                            const isEditing = editingCell === cellId;

                                            return (
                                                <td key={toZone} className={`px-1.5 py-1 text-center border-b border-r ${isDarkMode ? 'border-indigo-500/10' : 'border-black/10'}`}>
                                                    {isEditing ? (
                                                        <div className="flex items-center gap-1 justify-center">
                                                            <input
                                                                type="number"
                                                                value={editValue}
                                                                onChange={(e) => setEditValue(e.target.value)}
                                                                className={`w-14 px-1.5 py-0.5 text-[10px] font-semibold border-2 rounded-md focus:outline-none focus:ring-1 ${isDarkMode
                                                                    ? 'border-indigo-400 bg-black/80 text-white focus:ring-indigo-400 shadow-[0_0_12px_rgba(99,102,241,0.5)]'
                                                                    : 'border-black/20 bg-white text-black focus:ring-black'
                                                                    }`}
                                                                step="0.1"
                                                                autoFocus
                                                            />
                                                            <button
                                                                onClick={() => handleSaveEdit(fromZone, toZone)}
                                                                className={`p-0.5 rounded transition-colors ${isDarkMode ? 'text-emerald-400 hover:text-emerald-300 hover:bg-emerald-500/15' : 'text-black/60 hover:text-black'}`}
                                                            >
                                                                <Save size={11} />
                                                            </button>
                                                            <button
                                                                onClick={handleCancelEdit}
                                                                className={`p-0.5 rounded transition-colors ${isDarkMode ? 'text-red-400 hover:text-red-300 hover:bg-red-500/15' : 'text-black/60 hover:text-black'}`}
                                                            >
                                                                <X size={11} />
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className={`group/cell flex items-center justify-center gap-1 py-1 px-1 rounded-md cursor-pointer transition-all duration-150 ${isDarkMode
                                                                ? 'hover:bg-indigo-500/20 hover:shadow-[0_0_12px_rgba(99,102,241,0.35)]'
                                                                : 'hover:bg-black/10'
                                                                }`}
                                                            onClick={() => handleCellEdit(fromZone, toZone, rate)}
                                                        >
                                                            <span className={`text-[10px] font-semibold ${isDarkMode ? 'text-gray-100' : 'text-black'}`}>
                                                                ₹{rate}
                                                            </span>
                                                            <Edit2
                                                                size={9}
                                                                className={`opacity-0 group-hover/cell:opacity-100 transition-opacity ${isDarkMode ? 'text-indigo-300' : 'text-black'}`}
                                                            />
                                                        </div>
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

 const renderVasTable = () => {
    return (
        <div className="overflow-x-auto no-scrollbar -mx-3 sm:mx-0">
            <div className="inline-block min-w-full align-middle px-3 sm:px-0">
                <table className="min-w-full border-separate border-spacing-0">
                    <thead>
                        <tr className={isDarkMode ? 'bg-gradient-to-r from-indigo-950/80 via-purple-950/60 to-indigo-950/80' : 'bg-black/5'}>
                            <th className={`px-3 py-2.5 text-left text-[9px] font-bold uppercase tracking-wider border-b ${isDarkMode ? 'border-indigo-500/30 text-indigo-200' : 'border-black/10 text-black/70'}`}>Charge Key</th>
                            <th className={`px-3 py-2.5 text-left text-[9px] font-bold uppercase tracking-wider border-b ${isDarkMode ? 'border-indigo-500/30 text-indigo-200' : 'border-black/10 text-black/70'}`}>Label</th>
                            <th className={`px-3 py-2.5 text-left text-[9px] font-bold uppercase tracking-wider border-b ${isDarkMode ? 'border-indigo-500/30 text-indigo-200' : 'border-black/10 text-black/70'}`}>Type</th>
                            <th className={`px-3 py-2.5 text-left text-[9px] font-bold uppercase tracking-wider border-b ${isDarkMode ? 'border-indigo-500/30 text-indigo-200' : 'border-black/10 text-black/70'}`}>Condition</th>
                            <th className={`px-3 py-2.5 text-left text-[9px] font-bold uppercase tracking-wider border-b ${isDarkMode ? 'border-indigo-500/30 text-indigo-200' : 'border-black/10 text-black/70'}`}>Value</th>
                            <th className={`px-3 py-2.5 text-left text-[9px] font-bold uppercase tracking-wider border-b ${isDarkMode ? 'border-indigo-500/30 text-indigo-200' : 'border-black/10 text-black/70'}`}>Min</th>
                            <th className={`px-3 py-2.5 text-left text-[9px] font-bold uppercase tracking-wider border-b ${isDarkMode ? 'border-indigo-500/30 text-indigo-200' : 'border-black/10 text-black/70'}`}>Max</th>
                            <th className={`px-3 py-2.5 text-center text-[9px] font-bold uppercase tracking-wider border-b ${isDarkMode ? 'border-indigo-500/30 text-indigo-200' : 'border-black/10 text-black/70'}`}>Active</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vasPricing.map((vas, index) => {
                            const isLocked = lockedChargeKeys.includes(vas.charge_key);
                            const rowBg = isDarkMode
                                ? (index % 2 === 0 ? 'bg-transparent' : 'bg-indigo-500/[0.04]')
                                : (index % 2 === 0 ? 'bg-white' : 'bg-gray-50');

                            // 🔥 Common input classes (dark: solid bg + strong border)
                            const inputBase = isDarkMode
                                ? 'border-indigo-400/60 bg-[#1a1a2e] text-white placeholder-indigo-300/50 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/40 shadow-[inset_0_1px_0_rgba(255,255,255,0.05)]'
                                : 'border-black/30 bg-white text-black placeholder-black/40 focus:border-black focus:ring-1 focus:ring-black';

                            const inputDisabled = isDarkMode
                                ? 'border-indigo-400/30 bg-[#0f0f1c] text-indigo-200/70 cursor-not-allowed'
                                : 'border-black/20 bg-gray-100 text-black/60 cursor-not-allowed';

                            return (
                                <tr
                                    key={index}
                                    className={`${rowBg} transition-colors ${isDarkMode ? 'hover:bg-indigo-500/10' : 'hover:bg-black/5'} ${!vas.is_active ? 'opacity-60' : ''}`}
                                >
                                    {/* Charge Key */}
                                    <td className={`px-2 py-2 border-b ${isDarkMode ? 'border-indigo-500/15' : 'border-black/10'}`}>
                                        <input
                                            type="text"
                                            value={vas.charge_key}
                                            onChange={(e) => updateVasField(index, 'charge_key', e.target.value)}
                                            disabled={isLocked}
                                            className={`w-full px-2.5 py-1.5 text-[10px] font-medium border-2 rounded-md focus:outline-none transition-all ${isLocked ? inputDisabled : inputBase}`}
                                            placeholder="e.g., cod_charge"
                                        />
                                    </td>

                                    {/* Label */}
                                    <td className={`px-2 py-2 border-b ${isDarkMode ? 'border-indigo-500/15' : 'border-black/10'}`}>
                                        <input
                                            type="text"
                                            value={vas.label}
                                            onChange={(e) => updateVasField(index, 'label', e.target.value)}
                                            disabled
                                            className={`w-full px-2.5 py-1.5 text-[10px] font-medium border-2 rounded-md focus:outline-none transition-all ${inputDisabled}`}
                                            placeholder="e.g., COD Fee"
                                        />
                                    </td>

                                    {/* Type */}
                                    <td className={`px-2 py-2 border-b ${isDarkMode ? 'border-indigo-500/15' : 'border-black/10'}`}>
                                        <div className="relative">
                                            <select
                                                value={vas.charge_type}
                                                onChange={(e) => updateVasField(index, 'charge_type', e.target.value)}
                                                className={`w-full px-2.5 py-1.5 pr-7 text-[10px] font-medium border-2 rounded-md focus:outline-none appearance-none transition-all ${inputBase}`}
                                            >
                                                <option value="fixed">Fixed</option>
                                                <option value="percent">Percent</option>
                                            </select>
                                            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                                                <svg className={`h-3 w-3 ${isDarkMode ? 'text-indigo-300' : 'text-black/40'}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                        </div>
                                    </td>

                                    {/* Condition */}
                                    <td className={`px-2 py-2 border-b ${isDarkMode ? 'border-indigo-500/15' : 'border-black/10'}`}>
                                        <input
                                            type="text"
                                            value={vas.condition_value}
                                            onChange={(e) => updateVasField(index, 'condition_value', e.target.value)}
                                            className={`w-full px-2.5 py-1.5 text-[10px] font-medium border-2 rounded-md focus:outline-none transition-all ${inputBase}`}
                                            placeholder="e.g., invoice"
                                        />
                                    </td>

                                    {/* Value */}
                                    <td className={`px-2 py-2 border-b ${isDarkMode ? 'border-indigo-500/15' : 'border-black/10'}`}>
                                        <input
                                            type="number"
                                            value={vas.value}
                                            onChange={(e) => updateVasField(index, 'value', e.target.value)}
                                            className={`w-full px-2.5 py-1.5 text-[10px] font-semibold border-2 rounded-md focus:outline-none transition-all ${isDarkMode
                                                ? 'border-emerald-400/50 bg-[#1a1a2e] text-emerald-300 placeholder-indigo-300/50 focus:border-emerald-400 focus:ring-2 focus:ring-emerald-500/40 shadow-[inset_0_1px_0_rgba(255,255,255,0.05)]'
                                                : 'border-black/30 bg-white text-black placeholder-black/40 focus:border-black focus:ring-1 focus:ring-black'
                                                }`}
                                            step="0.01"
                                        />
                                    </td>

                                    {/* Min */}
                                    <td className={`px-2 py-2 border-b ${isDarkMode ? 'border-indigo-500/15' : 'border-black/10'}`}>
                                        <input
                                            type="number"
                                            value={vas.min_value}
                                            onChange={(e) => updateVasField(index, 'min_value', e.target.value)}
                                            className={`w-full px-2.5 py-1.5 text-[10px] font-medium border-2 rounded-md focus:outline-none transition-all ${inputBase}`}
                                            step="0.01"
                                        />
                                    </td>

                                    {/* Max */}
                                    <td className={`px-2 py-2 border-b ${isDarkMode ? 'border-indigo-500/15' : 'border-black/10'}`}>
                                        <input
                                            type="number"
                                            value={vas.max_value}
                                            onChange={(e) => updateVasField(index, 'max_value', e.target.value)}
                                            className={`w-full px-2.5 py-1.5 text-[10px] font-medium border-2 rounded-md focus:outline-none transition-all ${inputBase}`}
                                            step="0.01"
                                        />
                                    </td>

                                    {/* Active toggle */}
                                    <td className={`px-2 py-2 border-b ${isDarkMode ? 'border-indigo-500/15' : 'border-black/10'} text-center`}>
                                        <label className="inline-flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={vas.is_active}
                                                onChange={(e) => updateVasField(index, 'is_active', e.target.checked)}
                                                className={`w-4 h-4 rounded cursor-pointer ${isDarkMode
                                                    ? 'accent-indigo-500 bg-[#1a1a2e] border-2 border-indigo-400/60'
                                                    : 'accent-black bg-white border-black/30'
                                                    }`}
                                            />
                                        </label>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
    const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
    return (
        <>
            <style>{`
                .no-scrollbar {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                .no-scrollbar::-webkit-scrollbar {
                    display: none;
                }
            `}</style>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'bg-black' : 'bg-white'}`}>
                <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

                <NavBar />

                <div className="flex flex-1 overflow-hidden">

                    {isToggleSidebar && (
                        <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                            <Sidebar />
                        </div>
                    )}


                    <div className={`flex-1 overflow-y-auto no-scrollbar py-2 sm:py-4 ${isDarkMode ? 'bg-black' : 'bg-gray-100'}`}>
                        <div className="max-w-7xl mx-auto px-3 sm:px-2 lg:px-6">
                            <div className="mb-4 sm:mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                <div>
                                    <h1 className={`text-sm sm:text-base font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>B2B Rate Card Management</h1>
                                    <p className={`text-[10px] sm:text-xs mt-0.5 ${isDarkMode ? 'text-indigo-200/60' : 'text-gray-600'}`}>
                                        Configure shipping rates and VAS pricing for retailers and courier partners
                                    </p>
                                </div>

                                <div className="flex gap-2">
                                    <button
                                        onClick={() => handleTabClick("customized")}
                                        className={`px-3 py-2 text-[10px] sm:text-xs font-medium rounded-lg transition-all duration-200 ${activeTab === "customized"
                                            ? (isDarkMode ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg shadow-emerald-900/40' : 'bg-emerald-600 text-white')
                                            : (isDarkMode ? 'bg-emerald-600/20 text-emerald-200 hover:text-white hover:bg-emerald-600/30 border border-emerald-500/30' : 'bg-emerald-600 text-white')
                                            }`}
                                    >
                                        Customized Ratecard
                                    </button>
                                    <button
                                        onClick={() => handleTabClick("csv")}
                                        className={`px-3 py-1 text-[10px] sm:text-xs font-medium rounded-lg transition-all duration-200 ${activeTab === "csv"
                                            ? (isDarkMode ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg shadow-indigo-900/50' : 'bg-blue-600 text-white')
                                            : (isDarkMode ? 'bg-indigo-500/15 text-indigo-200 hover:text-white hover:bg-indigo-500/25 border border-indigo-500/30' : 'bg-blue-600 text-white')
                                            }`}
                                    >
                                        CSV Upload
                                    </button>
                                </div>
                            </div>

                            {activeTab === "customized" && (
                                <div>
                                    <div className={`border rounded-lg p-3 sm:p-4 mb-4 sm:mb-6 ${isDarkMode ? 'border-indigo-500/20 bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14]' : 'border-black/10 bg-white'}`}>
                                        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 items-end">
                                            <div className="flex flex-col gap-0.5">
                                                <label className={`text-[9px] font-medium ${isDarkMode ? 'text-indigo-200/80' : 'text-gray-700'}`}>Select Retailer <span className="text-red-500">*</span></label>
                                                <Select
                                                    value={selectedRetailer}
                                                    onChange={setSelectedRetailer}
                                                    options={retailers}
                                                    isLoading={loading}
                                                    isDisabled={loading}
                                                    placeholder={loading ? "Loading retailers..." : "Search retailer..."}
                                                    styles={customSelectStyles}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    isClearable={true}
                                                    noOptionsMessage={() => "No retailers found"}
                                                    loadingMessage={() => "Loading..."}
                                                />
                                            </div>

                                            <div className="flex flex-col gap-0.5">
                                                <label className={`text-[9px] font-medium ${isDarkMode ? 'text-indigo-200/80' : 'text-gray-700'}`}>Courier Partner <span className="text-red-500">*</span></label>
                                                <select
                                                    value={selectedCourier}
                                                    onChange={(e) => setSelectedCourier(e.target.value)}
                                                    className={`h-[32px] px-2 text-[10px] border rounded-lg focus:outline-none focus:ring-1 ${isDarkMode ? 'border-indigo-500/30 bg-black/60 text-white focus:ring-indigo-500/60' : 'border-black/20 bg-white text-black focus:ring-black'}`}
                                                >
                                                    <option value="">-- Select --</option>
                                                    {courierPartners.map((courier) => (
                                                        <option key={courier.id} value={courier.id}>
                                                            {courier.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="flex flex-col gap-0.5">
                                                <label className={`text-[9px] font-medium ${isDarkMode ? 'text-indigo-200/80' : 'text-gray-700'}`}>CFT Type <span className="text-red-500">*</span></label>
                                                <select
                                                    value={selectedCftType}
                                                    onChange={(e) => setSelectedCftType(e.target.value)}
                                                    disabled={loading}
                                                    className={`h-[32px] px-2 text-[10px] border rounded-lg focus:outline-none focus:ring-1 disabled:cursor-not-allowed ${isDarkMode ? 'border-indigo-500/30 bg-black/60 text-white focus:ring-indigo-500/60' : 'border-black/20 bg-white text-black focus:ring-black'}`}
                                                >
                                                    <option value="">-- Select --</option>
                                                    <option value="lite">Lite</option>
                                                    <option value="heavy">Heavy</option>
                                                    <option value="dense">Dense</option>
                                                </select>
                                            </div>

                                            <button
                                                onClick={setPricing}
                                                disabled={saving || !selectedRetailer || !selectedCourier || !dataLoaded}
                                                className={`h-[32px] px-3 text-[10px] font-semibold rounded-lg flex items-center justify-center gap-1.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${isDarkMode ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:from-indigo-500 hover:to-purple-500 shadow-lg shadow-indigo-900/50' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                                            >
                                                {saving ? (
                                                    <>
                                                        <RefreshCw size={12} className="animate-spin" />
                                                        Saving...
                                                    </>
                                                ) : (
                                                    <>
                                                        <Save size={12} />
                                                        Save
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    {success && (
                                        <div className={`mb-4 border rounded-lg p-3 ${isDarkMode ? 'border-emerald-500/30 bg-emerald-500/10' : 'border-black/20 bg-black/5'}`}>
                                            <div className="flex items-center gap-2">
                                                <CheckCircle className={isDarkMode ? 'text-emerald-400' : 'text-black'} size={14} />
                                                <p className={`text-xs font-medium ${isDarkMode ? 'text-emerald-300' : 'text-black'}`}>{success}</p>
                                            </div>
                                        </div>
                                    )}

                                    {error && (
                                        <div className={`mb-4 border rounded-lg p-3 ${isDarkMode ? 'border-red-500/30 bg-red-500/10' : 'border-red-300 bg-red-50'}`}>
                                            <div className="flex items-center gap-2">
                                                <AlertCircle className={isDarkMode ? 'text-red-400' : 'text-red-600'} size={14} />
                                                <p className={`text-xs font-medium ${isDarkMode ? 'text-red-400' : 'text-red-800'}`}>{error}</p>
                                            </div>
                                        </div>
                                    )}

                                    {renderRateTable()}

                                    {showVasModal && (
                                        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-2 sm:p-4">
                                            <div className={`border rounded-lg shadow-xl w-full max-w-6xl max-h-[90vh] overflow-y-auto no-scrollbar ${isDarkMode ? 'border-indigo-500/30 bg-gradient-to-br from-[#0b0b14] via-[#0d0d18] to-[#0b0b14] shadow-[0_8px_40px_rgba(79,70,229,0.35)]' : 'border-black/10 bg-white'}`}>
                                                <div className={`px-4 py-2 border-b flex items-center justify-between sticky top-0 z-10 ${isDarkMode ? 'border-indigo-500/20 bg-[#0b0b14]' : 'border-black/10 bg-white'}`}>
                                                    <h3 className={`text-xs font-bold ${isDarkMode ? 'text-white' : 'text-black'}`}>VAS Pricing Configuration</h3>
                                                    <button onClick={() => setShowVasModal(false)} className={isDarkMode ? 'text-indigo-300/70 hover:text-white' : 'text-black/60 hover:text-black'}>
                                                        <X size={16} />
                                                    </button>
                                                </div>

                                                <div className="p-3 sm:p-4">
                                                    {renderVasTable()}

                                                    <div className="mt-3 flex gap-2 justify-end">
                                                        <button
                                                            onClick={() => setShowVasModal(false)}
                                                            className={`px-4 py-1.5 text-[10px] font-medium border rounded-lg transition-colors ${isDarkMode ? 'border-indigo-500/40 text-indigo-200 hover:bg-indigo-500/15' : 'border-black/20 text-black hover:bg-black/10'}`}
                                                        >
                                                            Close
                                                        </button>
                                                        <button
                                                            onClick={() => setShowVasModal(false)}
                                                            className={`px-4 py-1.5 text-[10px] font-semibold rounded-lg flex items-center gap-1.5 transition-colors ${isDarkMode ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:from-indigo-500 hover:to-purple-500 shadow-lg shadow-indigo-900/50' : 'bg-black text-white hover:bg-black/90'}`}
                                                        >
                                                            <Save size={12} />
                                                            Apply
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {activeTab === "csv" && <RateCsvUplod />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default B2BSetRate;